import { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getTranslation } from '../../../translations/translations';
import AddedValueMessagesListing from '../../AddedValueMessages/AddedValueMessagesListing';
import PrdStickers from '../../PrdStickers/PrdStickers';

const PromoMessages = styled.div`
  width: 100%;
  box-sizing: border-box;
  line-height: 22px;
  color: #a21411;
  border-color: #a21411;
  border-width: 2px;
  text-align: center;
  text-transform: lowercase;

  &:first-letter {
    text-transform: uppercase;
  }

  .resultGrid & {
    margin: 10px 0;

    .rad {
      margin-bottom: 5px;
      color: #000;
      text-transform: none;

      > div {
        margin: 3px 0;
      }

      @media ${({ theme }) => `${theme.breakpoints.tablet}, ${theme.breakpoints.mobile}`} {
        font-size: 14px;
      }
    }
  }

  .rad {
    margin: 0 0 10px;
    font-size: 13px;

    img {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }

    i {
      font-size: 18px;
    }
  }

`;

const LabelOnlineOnly = styled.span`
  display: inline-block;
  margin: 2px 0;
  box-sizing: inherit;
  color: #954b22;
  line-height: normal;
  font-size: 12px;
  border: 1px solid #909090;
  background: #fff;
  white-space: nowrap;
  text-transform: uppercase;
  padding: 2px 42px;

  .resultList & {
    max-width: 191px;
  }

  .resultGrid & {
    width: 100%;
    padding: 2px 0px;
  }

  .product & {
    margin-top: 0;
  }
`;

const GridItemPromoMessages = ({ promoMessages, preOrder, loadImages }) => (
  <PromoMessages className={'promoMessages'}>
    {promoMessages?.isOnlineOnly && (
      <LabelOnlineOnly className={'label-online-only'}>
        {getTranslation('onlineOnlyTranslation')}
      </LabelOnlineOnly>
    )}

    {promoMessages?.badges && (
      <PrdStickers className={'prd-stickers'}>
        {loadImages &&
          promoMessages.badges.map((sticker, i) => (
            <img
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              src={sticker.src}
              alt={sticker.label}
            />
          ))}
      </PrdStickers>
    )}

    {promoMessages?.dealsAvailable && (
      <AddedValueMessagesListing view={'grid'} data={promoMessages.dealsAvailable} />
    )}
    {preOrder.available && (
      <div className={'rad'}>
        <i className={'dcg-icon-clock'} />
        {/* TODO: add to translations */}
        <strong>
          Available
          {/\d+\/\d+\/\d+/.test(preOrder.message)
            ? `\u00A0-\u00A0${preOrder.message}`
            : ' for pre-order'}
        </strong>
      </div>
    )}
    {promoMessages?.marketingMessages && (
      <div className={'rad'}>
        {promoMessages.marketingMessages.map((marketingMessage, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={i}>
            <i className={`dcg-icon-${marketingMessage.class}`} />
            <strong
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: marketingMessage.text }}
            />
          </Fragment>
        ))}
      </div>
    )}
  </PromoMessages>
);

GridItemPromoMessages.propTypes = {
  promoMessages: PropTypes.shape({
    dealsAvailable: PropTypes.arrayOf(PropTypes.object),
    isOnlineOnly: PropTypes.bool.isRequired,
    marketingMessages: PropTypes.arrayOf(
      PropTypes.shape({
        class: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      }).isRequired
    ),
    badges: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        src: PropTypes.string.isRequired
      })
    )
  }).isRequired,
  preOrder: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    message: PropTypes.string
  }).isRequired,
  loadImages: PropTypes.bool
};

GridItemPromoMessages.defaultProps = {
  loadImages: false
};

export default GridItemPromoMessages;
